import { notification } from "antd";
import { useCallback } from "react";
import { saveLogs } from "../services/copilot";
import { CopilotLog } from "../types/copilotLogs";

const fetcher = async (logs: CopilotLog[]) => {
  saveLogs({ copilotLogs: logs });
};

export const useSaveLogs = () => {
  return useCallback(async (logs: CopilotLog[]) => {
    try {
      fetcher(logs);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unknown error occurred!, eCode: 3",
      });
    }
  }, []);
};
